import { render, staticRenderFns } from "./LinkedItemList.vue?vue&type=template&id=41d15264&scoped=true"
import script from "./LinkedItemList.vue?vue&type=script&lang=js"
export * from "./LinkedItemList.vue?vue&type=script&lang=js"
import style0 from "./LinkedItemList.vue?vue&type=style&index=0&id=41d15264&prod&lang=scss&scoped=true"
import style1 from "./LinkedItemList.vue?vue&type=style&index=1&id=41d15264&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41d15264",
  null
  
)

export default component.exports